import { useTranslation } from 'react-i18next'
import { BriefingRequiredNextBanner } from '@/shared/briefing'
import type { RohsBriefingStep } from '../../utils/rohsLegislationBriefing'
import { ROHS_BRIEFING_ID_PREFIX } from './constants'
import { toV2RohsBriefingStep } from './toV2RohsBriefingStep'

export function V2RohsRequiredNextBanner({
  firstIncompleteStep,
}: {
  firstIncompleteStep: RohsBriefingStep | null
}) {
  const { t } = useTranslation('common')

  const firstIncompleteStepWithLabels =
    firstIncompleteStep != null ? toV2RohsBriefingStep(firstIncompleteStep, t) : null

  let incompleteMessage = ''
  if (firstIncompleteStepWithLabels != null) {
    incompleteMessage = t(
      'v2.pages.products.detail.rohsBriefing.requiredNext.stepMessage',
      {
        stepTitle: firstIncompleteStepWithLabels.title,
      }
    )
    if (firstIncompleteStep?.key === 'euDeclaration') {
      incompleteMessage = t(
        'v2.pages.products.detail.rohsBriefing.requiredNext.blockedByDeclaration',
        { stepTitle: firstIncompleteStepWithLabels.title }
      )
    }
  }

  const goToStepLabel =
    firstIncompleteStepWithLabels != null
      ? t('v2.pages.products.detail.rohsBriefing.requiredNext.goToStep', {
          stepTitle: firstIncompleteStepWithLabels.title,
        })
      : ''

  return (
    <BriefingRequiredNextBanner
      idPrefix={ROHS_BRIEFING_ID_PREFIX}
      title={t('v2.pages.products.detail.rohsBriefing.requiredNext.title')}
      allCompleteMessage={t(
        'v2.pages.products.detail.rohsBriefing.requiredNext.allComplete'
      )}
      incompleteMessage={incompleteMessage}
      goToStepLabel={goToStepLabel}
      firstIncompleteStep={firstIncompleteStepWithLabels}
    />
  )
}
